<template>
  <div class="center-warp">
    <div class="inner warp-page">
      <div class="top-nav">
        <div :class="navIndex == 1 ? 'on' : ''" @click="navChange(1)">本月新增客户({{newUser.count}})</div>
        <div :class="navIndex == 2 ? 'on' : ''" @click="navChange(2)">本月走访客户({{visitDoctors.count}})</div>
        <div :class="navIndex == 3 ? 'on' : ''" @click="navChange(3)">未建复诊卡病例({{unRevisitDoctors.count}})</div>
        <div :class="navIndex == 4 ? 'on' : ''" @click="navChange(4)">未办套餐病例({{unBuyPackageDoctors.count}})</div>
      </div>

      <!-- 显示医生列表 -->
      <template v-if="!showCaseList">
        <!-- 本月新增 -->
        <template v-if="navIndex == 1">
          <div class="center-toast"><i class="iconfont icon-tongzhi"></i>本月已新增 {{newUser.count}} 名学员，累计学员已达 {{newUser.totalCount}}名。坚持不懈总能遇到希望！</div>
          <div class="bottom-data">
            <div class="bottom-data-item" v-for=" item in newUser.list" :key="item.id">
              <img :src="item.head_pic" alt="">
              <div>
                <div class="bottom-data-item-info1">{{item.real_name}}医生</div>
                <div class="bottom-data-item-info2">{{item.province}}{{(item.province && item.city) ? '·' : ''}}{{item.city}}/{{item.organization}}</div>
              </div>
            </div>
            <Empty style="margin-top: calc(50vh - 250px)" v-if="!newUser.list.length" :info="'暂无本月新增客户'" :img-width="'200px'" />
          </div>
        </template>

        <!-- 走访客户 -->
        <template v-if="navIndex == 2">
          <div class="center-toast"><i class="iconfont icon-tongzhi"></i>本月已走访客户 {{visitDoctors.count}} 名，接近客户了解客户，把握市场最新动态！
          </div>
          <div class="bottom-data">
            <div class="bottom-data-item" v-for=" item in visitDoctors.list" :key="item.id">
              <img :src="item.head_pic" alt="">
              <div>
                <div class="bottom-data-item-info1">{{item.real_name}}医生</div>
                <div class="bottom-data-item-info2">{{item.province}}{{(item.province && item.city) ? '·' : ''}}{{item.city}}/{{item.organization}}</div>
              </div>
            </div>
            <Empty style="margin-top: calc(50vh - 250px)" v-if="!visitDoctors.list.length" :info="'暂无本月走访客户'" :img-width="'200px'" />
          </div>
        </template>

        <!-- 未建复诊卡病例 -->
        <template v-if="navIndex == 3">
          <div class="center-toast"><i class="iconfont icon-tongzhi"></i>本月还有 {{unRevisitDoctors.count}} 名咨询病例未创建复诊卡。主动为客户提供帮助，了解原因，和客户建立良好且信任的关系。
          </div>
          <div class="bottom-data">
            <div class="bottom-data-item" v-for=" item in unRevisitDoctors.list" :key="item.id" style="height: 118px">
              <img :src="item.head_pic" alt="">
              <div>
                <div class="bottom-data-item-info1">{{item.real_name}}医生</div>
                <div class="bottom-data-item-info2">{{item.province}}{{(item.province && item.city) ? '·' : ''}}{{item.city}}/{{item.organization}}</div>
              </div>
              <div class="bottom-data-case d-flex-between" @click="showDoctorCase(item, 3)">
                <div>{{item.count}}个病例</div>
                <div class="iconfont icon-youjiantou"></div>
              </div>
            </div>
            <Empty style="margin-top: calc(50vh - 250px)" v-if="!unRevisitDoctors.list.length" :info="'暂无未建复诊卡病例'" :img-width="'200px'" />
          </div>
        </template>

        <!-- 未办套餐病例 -->
        <template v-if="navIndex == 4">
          <div class="center-toast"><i class="iconfont icon-tongzhi"></i>近30天有 {{unBuyPackageDoctors.count}} 名病例被创建后未办理套餐，请联系客户跟进情况，提供支持。
          </div>
          <div class="bottom-data">
            <div class="bottom-data-item" v-for=" item in unBuyPackageDoctors.list" :key="item.id" style="height: 118px">
              <img :src="item.head_pic" alt="">
              <div>
                <div class="bottom-data-item-info1">{{item.real_name}}医生</div>
                <div class="bottom-data-item-info2">{{item.province}}{{(item.province && item.city) ? '·' : ''}}{{item.city}}/{{item.organization}}</div>
              </div>
              <div class="bottom-data-case d-flex-between" @click="showDoctorCase(item, 4)">
                <div>{{item.count}}个病例</div>
                <div class="iconfont icon-youjiantou"></div>
              </div>
            </div>
            <Empty style="margin-top: calc(50vh - 250px)" v-if="!unBuyPackageDoctors.list.length" :info="'暂无未办套餐病例'" :img-width="'200px'" />
          </div>
        </template>

        <!-- 分页 -->
        <Pagination v-if="navIndex == 1" :total="newUser.total" :page.sync="queryParams.page" :last_page="newUser.last_page" @pagination="getNewUser" :key="'page' + queryParams.page" />
        <Pagination v-if="navIndex == 2" :total="visitDoctors.total" :page.sync="queryParams.page" :last_page="visitDoctors.last_page" @pagination="getVisitDoctors" :key="'page' + queryParams.page" />
        <Pagination v-if="navIndex == 3" :total="unRevisitDoctors.total" :page.sync="queryParams.page" :last_page="unRevisitDoctors.last_page" @pagination="getUnRevisitDoctors" :key="'page' + queryParams.page" />
        <Pagination v-if="navIndex == 4" :total="unBuyPackageDoctors.total" :page.sync="queryParams.page" :last_page="unBuyPackageDoctors.last_page" @pagination="getUnBuyPackageDoctors" :key="'page' + queryParams.page" />
      </template>

      <!-- 显示医生病例 -->
      <div v-else v-loading="loading">
        <div class="case-list-head d-flex" @click="showCaseList = false">
            <div class="iconfont icon-fanhui"></div>
            <div>{{currentDoctor.real_name}}医生的病例（{{currentDoctor.count}}）</div>
        </div>
        <div class="filter-sort" style="width: 100%;margin-top: 10px">
          <div v-for="(item,index) in orderList" :class="index == orderIndex ? 'on' : ''" class="filter-sort-item"
               @click="orderChange(index)">{{ item.name }}·
            <span @click.stop="orderSortChange(index)" class="hover-bg">{{ item.param_name[orderSortIndex[index]] }}<i class="iconfont icon-qiehuan"></i></span>
          </div>
        </div>
        <div class="case-list-warp">
          <div class="case-list-item" v-for="item in patientList" :key="'patient' + item.id">
            <img :src="item.head_pic" alt="">
            <div class="case-list-item-name limit-1">{{item.name}}</div>
            <div class="case-list-item-age limit-1">{{item.age_text}}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  curMonthNewUser,
  curMonthVisitUser,
  unRevisitDoctorList,
  unPackageDoctorList,
  curMonthNoCreateFzCardUserPatientList,
  curMonthNoCreateTaocanUserPatientList,
} from "@/http/salesman_data";
import Pagination from "@/components/Pagination";
import {caseSortList} from "@/assets/js/caseSortList";

export default {
  name: "salesData",
  components: { Pagination },
  data() {
    return {
      navIndex: 1,
      newUser: {
        list: [],
        total: 0,
        last_page: 0,
        count: 0,
        totalCount: 0,
      },
      visitDoctors: {
        list: [],
        total: 0,
        last_page: 0,
        count: 0,
      },
      unRevisitDoctors: {
        list: [],
        total: 0,
        last_page: 0,
        count: 0,
      },
      unBuyPackageDoctors: {
        list: [],
        total: 0,
        last_page: 0,
        count: 0,
      },
      loading: false,
      queryParams: {
        page: 1,
        pageSize: 10,
      },
      showCaseList: false,
      currentDoctor: {},
      patientList: [],
      orderIndex:0,
      orderSortIndex:[0,0,0,0,0,0],
      orderList: caseSortList,
    };
  },
  mounted() {
    this.getNewUser();
    this.getVisitDoctors();
    this.getUnRevisitDoctors();
    this.getUnBuyPackageDoctors();
    if(this.$route.query.type) this.navChange(this.$route.query.type)
  },
  methods: {
    navChange(i) {
      this.navIndex = i;
      this.queryParams.page = 1;
      switch (i) {
        case 1:
          this.getNewUser();
          break;
        case 2:
          this.getVisitDoctors();
          break;
        case 3:
          this.getUnRevisitDoctors();
          break;
        case 4:
          this.getUnBuyPackageDoctors();
          break;
      }
      this.showCaseList = false;
      this.currentDoctor = {};
      this.patientList = [];
    },
    getNewUser() {
      this.loading = true;
      curMonthNewUser(this.queryParams).then((res) => {
        this.newUser.list = res.data.data.data;
        this.newUser.total = res.data.data.total;
        this.newUser.count = res.data.data.total;
        this.newUser.totalCount = res.data.totalCount;
        this.newUser.last_page = res.data.last_page;
        this.loading = false;
      });
    },
    getVisitDoctors() {
      this.loading = true;
      curMonthVisitUser(this.queryParams).then((res) => {
        this.visitDoctors.list = res.data.data.data;
        this.visitDoctors.total = res.data.data.total;
        this.visitDoctors.count = res.data.data.total;
        this.visitDoctors.last_page = res.data.last_page;
        this.loading = false;
      });
    },
    getUnRevisitDoctors() {
      this.loading = true;
      unRevisitDoctorList(this.queryParams).then((res) => {
        this.unRevisitDoctors.list = res.data.data.data;
        this.unRevisitDoctors.total = res.data.data.total;
        this.unRevisitDoctors.count = res.data.totalCount;
        this.unRevisitDoctors.last_page = res.data.last_page;
        this.loading = false;
      });
    },
    getUnBuyPackageDoctors() {
      this.loading = true;
      unPackageDoctorList(this.queryParams).then((res) => {
        this.unBuyPackageDoctors.list = res.data.data.data;
        this.unBuyPackageDoctors.total = res.data.data.total;
        this.unBuyPackageDoctors.count = res.data.totalCount;
        this.unBuyPackageDoctors.last_page = res.data.last_page;
        this.loading = false;
      });
    },
    showDoctorCase(item, type) {
      this.showCaseList = true;
      this.currentDoctor = item;
      this.getPatientList(type);
    },
    getPatientList(type) {
      this.loading = true;
      let orderBy = []
      orderBy.push(this.orderList[this.orderIndex].param)
      orderBy.push(this.orderList[this.orderIndex].param_order[this.orderSortIndex[this.orderIndex]])
      var query = {
        pageSize: 999,
        doctor_id: this.currentDoctor.id,
        orderBy: orderBy,
      };
      if (type == 3) {
        curMonthNoCreateFzCardUserPatientList(query).then((res) => {
          this.patientList = res.data.data;
          this.loading = false;
        });
      } else {
        curMonthNoCreateTaocanUserPatientList(query).then((res) => {
          this.patientList = res.data.data;
          this.loading = false;
        });
      }
    },
    orderChange(i) {
      this.orderIndex = i
      this.getPatientList(this.navIndex)
    },
    orderSortChange(i) {
      this.$set(this.orderSortIndex,i,Math.abs(this.orderSortIndex[i] - 1))
      if(i == this.orderIndex) this.getPatientList(this.navIndex)
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/sales_data.css";
</style>
